export const MEMBERACTIVITY_RANKING_HEADERS = [
  {
    name: "Rank",
    key: "rank",
    type: "text",
    width: "90px",
  },
  // {
  //   name: "Tier",
  //   key: "tier",
  //   type: "text",
  //   width: "196px",
  //   iconUrl: "assets/images/gold-badge.svg",
  // },
  {
    name: "Name",
    key: "name",
    type: "text",
    width: "196px",
    avatarKey: "profilePic",
    // iconUrl: "assets/images/info-line.svg",
    event:"viewUserDetails"
  },
  {
    name: "Usertype",
    key: "roles",
    type: "text",
    width: "196px",
  },
  {
    name: "Followers",
    key: "followers",
    type: "text",
    width: "196px",
  },
  {
    name: "No. Of Logins",
    key: "logins",
    type: "text",
    width: "196px",
  },
  {
    name: "Avg Duration",
    key: "avgDurationSeconds",
    type: "text",
    width: "196px",
  },
  {
    name: "Streaks",
    key: "streak",
    type: "text",
    width: "196px",
  },
];

export const CONTRIBUTOR_RANKING_HEADERS = [
  {
    name: "Rank",
    key: "rank",
    type: "text",
    width: "90px",
  },
  // {
  //   name: "Tier",
  //   key: "tier",
  //   type: "text",
  //   width: "196px",
  //   iconUrl: "assets/images/gold-badge.svg",
  // },
  {
    name: "Name",
    key: "username",
    type: "text",
    width: "196px",
    avatarKey: "profilePic",
    iconUrl: "assets/images/info-line.svg",
    event:"viewUserDetails"
  },
  {
    name: "Organization Name",
    key: "organizationName",
    type: "text",
    width: "196px",
    event: "viewOrgDetails",
  },
  {
    name: "Published",
    key: "totalPublished",
    type: "text",
    width: "196px",
  },
  {
    name: "Upvotes",
    key: "upvotes",
    type: "text",
    width: "196px",
  },
  {
    name: "Downloads",
    key: "downloads",
    type: "text",
    width: "196px",
  },
];

export const ARTEFACT_RANKING_HEADERS = [
  {
    name: "Rank",
    key: "rank",
    type: "text",
    width: "90px",
  },
  {
    name: "Artefact Name",
    key: "name",
    type: "text",
    width: "196px",
    event: "viewArtefactDetails",
  },
  {
    name: "Artefact type",
    key: "type",
    type: "text",
    width: "196px",
  },
  {
    name: "Published By",
    key: "publisherName",
    type: "text",
    width: "196px",
    avatarKey: "publisherImage",
    iconUrl: "assets/images/info-line.svg",
  },
  {
    name: "Downloads",
    key: "downloads",
    type: "text",
    width: "196px",
  },
  {
    name: "Upvotes",
    key: "upvotes",
    type: "text",
    width: "196px",
  },
];

export const ORGANIZATION_RANKING_HEADERS = [
  {
    name: "Rank",
    key: "rank",
    type: "text",
    width: "90px",
  },
  {
    name: "Organization Name",
    key: "organizationName",
    type: "text",
    width: "196px",
    event: "viewOrgDetails",
  },
  {
    name: "Org. type",
    key: "organizationType",
    type: "text",
    width: "196px",
  },
  {
    name: "Published",
    key: "published",
    type: "text",
    width: "196px",
  },
  {
    name: "Upvotes",
    key: "upvotes",
    type: "text",
    width: "196px",
  },
  {
    name: "Downloads",
    key: "downloads",
    type: "text",
    width: "196px",
  },
  {
    name: "Members",
    key: "members",
    type: "text",
    width: "196px",
    // iconUrl: "assets/images/redirectt.svg",
    // showAfterText: true,
    event: "viewOrgMembers",
    title: "View Members",
  },
];

export const SECTOR_RANKING_HEADERS = [
  {
    name: "Rank",
    key: "rank",
    type: "text",
    width: "90px",
  },
  {
    name: "Sector",
    key: "name",
    type: "text",
    width: "196px",
  },
  {
    name: "Uploads",
    key: "uploads",
    type: "text",
    width: "196px",
  },
  {
    name: "Upvotes",
    key: "upvotes",
    type: "text",
    width: "196px",
  },
  {
    name: "Downloads",
    key: "downloads",
    type: "text",
    width: "196px",
  },
];

export const ORGANIZATION_MEMBER_HEADERS = [
  {
    name: "Rank",
    key: "rank",
    type: "text",
    width: "90px",
  },
  // {
  //   name: "Tier",
  //   key: "tier",
  //   type: "text",
  //   width: "196px",
  //   iconUrl: "assets/images/gold-badge.svg",
  // },
  {
    name: "Contributors",
    key: "username",
    type: "text",
    width: "196px",
    avatarKey: "profilePic",
    iconUrl: "assets/images/info-line.svg",
  },
  {
    name: "Published",
    key: "totalPublished",
    type: "text",
    width: "100px",
  },
  {
    name: "Upvotes",
    key: "upvotes",
    type: "text",
    width: "100px",
  },
  {
    name: "Downloads",
    key: "downloads",
    type: "text",
    width: "120px",
  },
];

export const SORTING_OPTIONS = [
  {
    label: "Downloads - High to Low",
    value: "downloads_desc",
  },
  {
    label: "Downloads - Low to High",
    value: "downloads_asc",
  },
  {
    label: "Contribution - High to Low",
    value: "uploads_desc",
  },
  {
    label: "Contribution - Low to High",
    value: "uploads_asc",
  },
  // {
  //   label: "Uploads - High to Low",
  //   value: "uploads_desc",
  // },
  // {
  //   label: "Uploads - Low to High",
  //   value: "uploads_asc",
  // },
  {
    label: "Upvotes - High to Low",
    value: "upvotes_desc",
  },
  {
    label: "Upvotes - Low to High",
    value: "upvotes_asc",
  },
];

export const MEMBER_ACTIVITY_SORTING_OPTIONS = [
  {
    label: "Followers - High to Low",
    value: "followers_desc",
  },
  {
    label: "Followers - Low to High",
    value: "followers_asc",
  },
  {
    label: "No. of Logins - High to Low",
    value: "logins_desc",
  },
  {
    label: "No. of Logins - Low to High",
    value: "logins_asc",
  },
  {
    label: "Avg. Duration - High to Low",
    value: "avg_duration_desc",
  },
  {
    label: "Avg. Duration - Low to High",
    value: "avg_duration_asc",
  },
  {
    label: "Streak - High to Low",
    value: "streak_desc",
  },
  {
    label: "Streak - Low to High",
    value: "streak_asc",
  },
];

export enum RankingTab {
  member_activity = "member_activity",
  contributor = "contributor",
  artefact = "artefacts",
  organization = "organization",
  sector = "sector",
}

export const TABS = [
  {
    name: "Member Activity",
    value: "member_activity",
  },
  {
    name: "Contributor",
    value: "contributor",
  },
  {
    name: "Artefacts",
    value: "artefacts",
  },
  {
    name: "Organization",
    value: "organization",
  },
  {
    name: "Sector",
    value: "sector",
  },
];

export const MEMBER_ACTIVITY_FILTER_CONFIG = {
  uploadedOn: true,
  userType: true,
  organizationType: true,
  sourceOrganization: true,
  sectors: true,
};

export const CONTRIBUTOR_FILTER_CONFIG = {
  uploadedOn: true,
  artifactType: true,
  organizationType: true,
  sectors: true,
};
export const ARTEFACT_FILTER_CONFIG = {
  uploadedOn: true,
  artifactType: true,
  visibility: true,
  sectors: true,
  organizationType: true,
};
export const ORGANIZATION_FILTER_CONFIG = {
  uploadedOn: true,
  organizationType: true,
  artifactType: true,
  sectors: true,
};
export const SECTOR_FILTER_CONFIG = {
  uploadedOn: true,
};
